/**
 *
 * Asynchronously loads the component for DevControlPanelAuditTable
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/DevControlPanelAuditTable/loadable.js